import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

export default function BookingPrompt({ hero = false }) {
  return (
    <div className={`booking-prompt${hero ? ' booking-prompt-hero' : ''}`}>
      <div className="booking-prompt-copy">
        <span className="eyebrow">A stay to look forward to</span>
        <p>Plan your visit and send an enquiry about availability.</p>
      </div>
      <Link className="button button-gold" to="/booking">
        {hero ? 'Check Availability' : 'Book Your Stay'} <SafeIcon name="ArrowRight" />
      </Link>
    </div>
  );
}